import Image from '@app/components/image';
import { HomeFeaturedCardContext } from '@app/domains/home/components/HomeFeaturedCard';
import { useContext } from 'react';

export default function BackgroundLayer() {
    const { cardColor, cardImageUrl } = useContext(HomeFeaturedCardContext);
    return (
        <>
            <div className="relative">
                <div className="h-200">
                    <Image className="h-full w-full object-cover" src={cardImageUrl} alt="card-background-image" />
                </div>
                <div style={{ backgroundColor: cardColor }} className="h-120 md:h-48"></div>
            </div>
        </>
    );
}
